/**
 * DatePickerButton Component
 *
 * A button that opens a date picker dialog
 */

import React, {useState} from 'react';
import DatePickerDialog from './DatePickerDialog';
import AppInput from './AppInput';
import {Calendar} from 'lucide-react';
import {formatDate} from '../../utils/dateUtils';

interface DatePickerButtonProps {
  value?: string;
  onChange: (date: string | undefined) => void;
  label?: string;
  placeholder?: string;
  minDate?: string;
  maxDate?: string;
  className?: string;
  error?: string;
  disabled?: boolean;
}

const DatePickerButton: React.FC<DatePickerButtonProps> = ({
  value,
  onChange,
  label,
  placeholder = 'اختر التاريخ',
  minDate,
  maxDate,
  className = '',
  error,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenDialog = () => {
    if (!disabled) {
      setIsOpen(true);
    }
  };

  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  const handleDateSelect = (date: string) => {
    onChange(date);
  };

  const displayValue = value ? formatDate(value) : '';

  return (
    <>
      <div className="relative">
        <AppInput
          type="text"
          label={label}
          value={displayValue}
          readOnly
          placeholder={placeholder}
          className={`cursor-pointer pr-12 ${className}`}
          error={error}
          disabled={disabled}
          onClick={handleOpenDialog}
          onFocus={handleOpenDialog}
        />
        <button
          type="button"
          onClick={handleOpenDialog}
          disabled={disabled}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-primary transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed p-1 rounded-lg hover:bg-gray-50"
          aria-label="فتح التقويم"
        >
          <Calendar className="w-5 h-5" />
        </button>
      </div>

      <DatePickerDialog
        open={isOpen}
        onClose={handleCloseDialog}
        onSelect={handleDateSelect}
        selectedDate={value}
        minDate={minDate}
        maxDate={maxDate}
      />
    </>
  );
};

export default DatePickerButton;

